// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30ePb","fullView":"styles_fullView__6qo0v"};